import {
    BundleLink,
    BundleMallCount,
    BundleName,
    BundlePrice, BundlePriceUnit,
    BundleRankingLabel, BundleStatus, WrapperBundle,
    WrapperBundleName,
    WrapperBundlePrice, WrapperButtonGroup,
    WrapperInfo
} from "./bundleItem.style";
import AddCompare from "../../../buttons/addCompare";
import ItemComparison from "../../item_comparison";
import React from "react";
import {useSelector} from "react-redux";
import {googleTagApi} from "../../../api/googleTag";
import {ga4_clickItem} from "../../../../libs/googleTagmanager";
import {priceValue} from "../../../../utils/priceValue";

export default function BundleItem({bundleItem}) {
    const {minishopInfo, domain, lists} = useSelector(state => state.initial)
    const isSellBundle = (bundleItem.f_sellout === 0 && bundleItem.price !==0)
    const BundleIsShow = priceValue(bundleItem.f_sellout, bundleItem.price, bundleItem.cnt_stock, bundleItem.seller, domain).isShow
    const BundleStatusText = priceValue(bundleItem.f_sellout, bundleItem.price, bundleItem.cnt_stock, bundleItem.seller, domain).statusText

    /**
     * 번들 클릭 시 이동할 상품상세 페이지 링크
     * @type {string}
     */
    const itemLink = `${process.env.REACT_APP_SHOPPING_URL}/detail/${bundleItem.item_id}${minishopInfo ? `/${minishopInfo.pr_idx}` : ''}`

    /**
     * domain에 따라 CSS가 달리 적용 되야 하는 경우 정리
     * @type {{}}
     */
    let styleProps = {}
    switch (domain){
        case 'pc':{
            styleProps = {
                ...styleProps,
                wrapperBundleWidth : '412px',
                wrapperInfoWidth : '323px',
                wrapperButtonGroupWidth : lists.itemList?.isCompare === 1 ? '86px' : '',
                wrapperButtonGroupPadding : lists.itemList?.isCompare === 1 ? '0px 0px 0px 25px': '0',
                BundleStatusRight : '-27px'
            }
            break
        }
        case 'shopping':{
            styleProps = {
                ...styleProps,
                wrapperBundleWidth : '438px',
                wrapperInfoWidth : '373px',
                wrapperButtonGroupWidth : lists.itemList?.isCompare === 1 ? '50px': '',
                wrapperButtonGroupPadding : lists.itemList?.isCompare === 1 ? '0px 20px 0px 0px' : '0',
                BundleStatusRight : '0px'
            }
            break
        }
        default :
            styleProps = {
                ...styleProps,
                wrapperBundleWidth : '412px',
                wrapperInfoWidth : '323px',
                wrapperButtonGroupWidth : '86px',
                wrapperButtonGroupPadding : '0px 0px 0px 25px',
                BundleStatusRight : '-27px'
            }
    }

    /**
     * 견적추가, 견적비교 버튼은 공통 컴포너트
     * 상품그룹일 경우 CSS를 달리 해야하는 경우를 정리하여 props로 전달
     * @type {{button_right: number, position: string, right: string, button_top: number, hoverWidth: number}}
     */

    /**
     * 견적 추가 버튼 css props
     * @type {{button_right: number, position: string, right: string, button_top: number, hoverWidth: number}}
     */
    const addCompareStyle = {
        button_top: 0,
        button_right : -81,
        hoverWidth : 109,
        position : 'absolute',
        right : '60px'
    }

    /**
     * 가격 비교 체크박스 css props
     * @type {{buttonHover: {right: string}, buttonStyle: string, checkBoxStyle: {activeFontSize: number, width: number, height: number}}}
     */

    const comparisonStyle = {
        buttonStyle : `
        position: absolute;
        right : -9px;
        display: flex;
        white-space: nowrap;
        padding: 0 9px;
        margin: 0 0 0 1px;
        height: 27px;
        align-items: center;
        border: 1px solid transparent;
        z-index: 2;`,
        buttonHover : {
            right : '-68px'
        },
        checkBoxStyle :{
            width : 16,
            height : 16,
            activeFontSize :15,
        },
    }

    /**
     * 클릭 시 GA4 통신 코드
     * @param item
     */
    const itemListItemClick = (item) => {
        if (domain === 'shopping' || domain === 'pc') {
                // GA API 호출
                googleTagApi(item.item_id).then((value) => {
                    if (value?.data?.success === true) {
                        const tag_item = value.data.result
                        ga4_clickItem({ item, tag_item, list_name: domain + '.list' })
                        // ua_clickItem({ item, tag_item, list_name: domain + '.list' })
                    } else {
                        console.log('통신 오류')
                        return false;
                    }
                })
        }
    }


    return (
        <WrapperBundle styleProps={styleProps}>
            <WrapperInfo styleProps={styleProps}>
                <BundleLink href={itemLink} onClick={()=>itemListItemClick(bundleItem)} target="_blank" rel="noopener noreferrer" styleProps={styleProps}>
                    <WrapperBundleName>
                        <BundleName>{bundleItem.bundle_nm}</BundleName>
                        {bundleItem.bundle_rank < 3 &&
                            <BundleRankingLabel>{bundleItem.bundle_rank}위</BundleRankingLabel>}
                    </WrapperBundleName>
                    { BundleIsShow &&
                        <WrapperBundlePrice>
                            <BundlePrice>{bundleItem.price.toLocaleString('ko-KR')}</BundlePrice>
                            <BundlePriceUnit>원</BundlePriceUnit>
                        </WrapperBundlePrice>
                    }
                    { !BundleIsShow && <BundleStatus styleProps={styleProps}>
                        {BundleStatusText}
                    </BundleStatus> }
                </BundleLink>
            </WrapperInfo>
            <WrapperButtonGroup styleProps={styleProps}>
                {(domain !=='shopping' && isSellBundle && BundleIsShow)
                    && <AddCompare size={27} item={bundleItem} addCompareStyle={addCompareStyle} cnt_firm_b2={bundleItem.cnt_firm_b2} />
                }

                {domain === 'shopping' && <BundleMallCount>{bundleItem.market_real_count.toLocaleString('ko-KR')}몰</BundleMallCount>}
                <ItemComparison data={bundleItem} comparisonStyle={comparisonStyle}/>
            </WrapperButtonGroup>
        </WrapperBundle>
    )
}



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/bundleGroup/bundleItem/index.js